var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9299890",
    clipPath: "url(#clip0_0_3560)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.125 38.05H1.05V38.125V39.375V39.45H1.125H39.875H39.95V39.375V38.125V38.05H39.875H1.125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.3625 5.3125V5.3875H31.4375H32.6875H32.7625V5.3125C32.7625 4.83517 33.1477 4.45 33.625 4.45C34.1023 4.45 34.4875 4.83517 34.4875 5.3125C34.4875 5.78983 34.1023 6.175 33.625 6.175C33.2398 6.175 32.925 6.48983 32.925 6.875V8.4375V8.5125H33H34.25H34.325V8.4375V7.46139C35.2283 7.16676 35.8875 6.31457 35.8875 5.3125C35.8875 4.06483 34.8727 3.05 33.625 3.05C32.3773 3.05 31.3625 4.06483 31.3625 5.3125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33 9.3H32.925V9.375V10.625V10.7H33H34.25H34.325V10.625V9.375V9.3H34.25H33Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.625 0.55C30.1398 0.55 27.3 3.38983 27.3 6.875C27.3 10.3602 30.1398 13.2 33.625 13.2C37.1102 13.2 39.95 10.3602 39.95 6.875C39.95 3.38983 37.1102 0.55 33.625 0.55ZM33.625 11.8C30.9102 11.8 28.7 9.58983 28.7 6.875C28.7 4.16017 30.9102 1.95 33.625 1.95C36.3398 1.95 38.55 4.16017 38.55 6.875C38.55 9.58983 36.3398 11.8 33.625 11.8Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.375 36.95H27.45V36.875V25.625C27.45 25.2398 27.1352 24.925 26.75 24.925H23C22.6148 24.925 22.3 25.2398 22.3 25.625V36.875V36.95H22.375H23.625H23.7V36.875V26.325H26.05V36.875V36.95H26.125H27.375Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.625 36.95H18.7V36.875V21.875C18.7 21.4898 18.3852 21.175 18 21.175H14.25C13.8648 21.175 13.55 21.4898 13.55 21.875V36.875V36.95H13.625H14.875H14.95V36.875V22.575H17.3V36.875V36.95H17.375H18.625Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.2 36.875V29.45H8.55V36.875V36.95H8.625H9.875H9.95V36.875V28.75C9.95 28.3648 9.63517 28.05 9.25 28.05H5.5C5.11483 28.05 4.8 28.3648 4.8 28.75V36.875V36.95H4.875H6.125H6.2V36.875Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.21092 21.7885L15.0475 15.1532L23.4356 17.5471C23.6804 17.617 23.9461 17.5474 24.1217 17.3718L27.8717 13.6218L27.9248 13.5687L27.8717 13.5157L26.9905 12.6345L26.9375 12.5814L26.8844 12.6345L23.4281 16.0908L15.0768 13.7029L15.0765 13.7028C14.8539 13.6402 14.6087 13.6882 14.4322 13.8432C14.432 13.8434 14.4318 13.8435 14.4317 13.8437L6.30776 20.7177L6.2506 20.7661L6.29886 20.8233L7.10511 21.7796L7.15356 21.8371L7.21092 21.7885Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.125 25.55H31.05V25.625V28.125V28.2H31.125H32.375H32.45V28.125V25.625V25.55H32.375H31.125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.875 25.55H34.8V25.625V28.125V28.2H34.875H36.125H36.2V28.125V25.625V25.55H36.125H34.875Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M31.125 21.175H31.05V21.25V23.75V23.825H31.125H32.375H32.45V23.75V21.25V21.175H32.375H31.125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M34.875 21.175H34.8V21.25V23.75V23.825H34.875H36.125H36.2V23.75V21.25V21.175H36.125H34.875Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31.125 29.925H31.05V30V32.5V32.575H31.125H32.375H32.45V32.5V30V29.925H32.375H31.125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.875 29.925H34.8V30V32.5V32.575H34.875H36.125H36.2V32.5V30V29.925H36.125H34.875Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.875 34.3H34.8V34.375V36.875V36.95H34.875H36.125H36.2V36.875V34.375V34.3H36.125H34.875Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M31.125 34.3H31.05V34.375V36.875V36.95H31.125H32.375H32.45V36.875V34.375V34.3H32.375H31.125Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M31.05 19.375V19.45H31.125H32.375H32.45V19.375V17.575H34.8V19.375V19.45H34.875H36.125H36.2V19.375V16.875C36.2 16.4898 35.8852 16.175 35.5 16.175H31.75C31.3648 16.175 31.05 16.4898 31.05 16.875V19.375Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.5e5d4e01ac9e31e975b9e49c417bc3c6.svg";
export { ForwardRef as ReactComponent };